export default __webpack_public_path__ + "static/media/soluciones__2.e187c815.jpg";